import React from 'react'

const dashboard = () => {
  return (
    <h2 className="mb-4">Dashboard</h2>
  )
}

export default dashboard